import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import Header from "components/UpdateUi/Header/Header";
import Footer from "components/UpdateUi/Footer/Footer";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import InnerContent from "components/UpdateUi/InnerContent/InnerContent";
import SidebarLinks from "components/UpdateUi/SideBar/SideBarLink";
import { useDispatch } from "react-redux";
import { saveUserProfileInfo } from "store/reducers/login/LoginSlice";
import AdminHeader from "components/UpdateUi/Header/AdminHeader/Header";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  const { authToken } = useSelector((state) => state.login.authData);
  const dispatch = useDispatch();
  const { mobileNumber, portalUserMobileNumber } = useSelector((state) => state.login.userData);
  const { enabled } = useSelector((state) => state?.login?.adminPortalData) || false;
  const { userProfileInfo } = useSelector((state) => state.login);
  const mobileNum = enabled ? portalUserMobileNumber : mobileNumber;
  const [userDetailsData, setUserDetailsData]=useState({})
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = useRef(null);
  // states and functions
  const [color, setColor] = useState("blue");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [outletData, setOutletData] = useState({});
  const [callInProgress, setCallInProgress] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };
  useEffect(() => {
    getFeatureFlag();
    getUserDetails();
    if (
      mobileNumber &&
      Object.keys(userProfileInfo || {}).length === 0
    ) {
      fetchLoanSummary();
    }
  }, [mobileNumber]);
  const getFeatureFlag = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    setCallInProgress(false);
    setOutletData(result?.data);
  };

  const getUserDetails = async () => {
     setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
     setCallInProgress(false);
    setUserDetailsData(result?.data);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    } else {
      // setShowSidebar(true);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
 React.useEffect(() => {
  let psInstance = null;
  const isWindows =
    navigator.platform &&
    navigator.platform.indexOf("Win") > -1;

  if (isWindows && mainPanel.current) {
    psInstance = new PerfectScrollbar(mainPanel.current, {
      suppressScrollX: true,
      suppressScrollY: false,
    });
    document.body.style.overflow = "hidden";
  }
  window.addEventListener("resize", resizeFunction);
  // Cleanup
  return function cleanup() {
    if (psInstance) {
      psInstance.destroy();
      psInstance = null;
    }
    document.body.style.overflow = "";
    window.removeEventListener("resize", resizeFunction);
  };
}, []);
  const fetchLoanSummary = async () => {
    const result = await apiHandler({
      url: endpoint.USER_DATA_MOBILE_NUMBER_API + mobileNum,
      method: "GET",
      authToken,
    });

    if (!result?.data?.error_code) {
      dispatch(saveUserProfileInfo(result.data));
    }
  };
const sideBarLinks = SidebarLinks.map((item) => {
  if (!item.children) {
    return enabled ? item : null;
  }
  return {
    ...item,
    children: item.children.filter((child) => {
      if (enabled) {
        return !["APPLICATIONS", "ACTIVE_LOANS"].includes(child.status);
      }
      return ["APPLICATIONS", "ACTIVE_LOANS"].includes(child.status);
    }),
  };
}).filter(Boolean);

  if(callInProgress){
    return <CircularProgresss callInProgress={callInProgress} />
  }
  return (
    <div className={classes.wrapper}>
      <div className={classes.mainPanel} ref={mainPanel}>
        {enabled ?
          <AdminHeader handleDrawerToggle={handleDrawerToggle} userDetailData={userDetailsData}/>
        :
          <Header handleDrawerToggle={handleDrawerToggle} userDetailData={outletData}/>
        }
        <div style={{ display: "flex", background:"linear-gradient(180deg, #FFFFFF 0%, #F5F8FF 100%)" }}>
          <div className={classes.content}>
            <div className={classes.container}>
             <InnerContent
                handleSidebarToggle={handleSidebarToggle}
                handleDrawerToggle={handleDrawerToggle}
                mobileOpen={mobileOpen}
                outletData={outletData}
                sideBarLinks={sideBarLinks}
                enabled={enabled}
                designation={userDetailsData?.designation}
                roleUser={userDetailsData?.role}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
